import { getData, postData } from './common.service';

const BASE = '/enquiries';
const AUTH = {
  basePath: process.env.REACT_APP_CORE_API_BASEPATH,
  sendTokenInHeader: true,
};

export enum EnquiryStatus {
  NEW = 'NEW',
  OPEN = 'OPEN',
  PURCHASED = 'PURCHASED',
  NOT_PURCHASED = 'NOT_PURCHASED',
}

export async function getEnquiries(
  where: Record<string, any> = {},
  limit = 50,
  skip = 0,
  order = 'created_date DESC',
): Promise<any[]> {
  const filter = JSON.stringify({ where, limit, skip, order });
  const res = await getData(`${BASE}?filter=${encodeURIComponent(filter)}`, AUTH).then((data: any) => data.json());
  return Array.isArray(res) ? res : [];
}

export async function getEnquiriesCount(where: Record<string, any> = {}): Promise<number> {
  const url = Object.keys(where).length
    ? `${BASE}/count?where=${encodeURIComponent(JSON.stringify(where))}`
    : `${BASE}/count`;
  const res = await getData(url, AUTH).then((data: any) => data.json());
  return res?.count ?? 0;
}

export async function getEnquiryById(id: string): Promise<any> {
  return getData(`${BASE}/${id}`, AUTH).then((data: any) => data.json());
}

export interface CreateEnquiryBody {
  name: string;
  mobile: string;
  email?: string;
  location?: string;
  message?: string;
  assigneeId?: string;
  expectedQuantity?: number;
  expectedItemType?: string;
}

export async function createEnquiry(body: CreateEnquiryBody): Promise<any> {
  return postData(BASE, {
    ...AUTH,
    body,
    headers: { 'Content-Type': 'application/json' },
  }).then((data: any) => data.json());
}

export async function updateEnquiry(
  id: string,
  body: { status?: string; comment?: string; assigneeId?: string },
): Promise<any> {
  return postData(`${BASE}/${id}`, {
    ...AUTH,
    body,
    usePutMethod: true,
    headers: { 'Content-Type': 'application/json' },
  }).then((data: any) => data.json());
}
